// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2paBb","label":"SetPasswdForm_label__3dJqB"};